import React, { useState, useEffect } from "react";
import styled from "styled-components";

interface ProgressProps {
  width: number;
  progressShow?: boolean;
}

const ProgressBarContainer = styled.div`
  width: 100%;
  max-width: 100%;
  height: 25px;
  background: var(--kiosk-gray-50, #f6f7fb);
  box-shadow: 6px 6px 20px 0px rgba(0, 0, 0, 0.2) inset;
  border-radius: 12px;
  font-weight: 600;
  font-size: 0.8rem;
  margin-top: 0px;
  overflow: hidden;
`;

const Progress = styled.div<ProgressProps>`
  width: ${(props) => props.width}%;
  height: 100%;
  max-width: 100%;
  padding: 0;
  text-align: center;
  background: var(
    --kiosk-primary-g,
    linear-gradient(180deg, #3e83f1 0%, #4667d9 100%)
  );
  color: #111;
  transition: width 1s; /* 진행 시 애니메이션 설정 */
`;

const ProgressBar: React.FC<ProgressProps> = ({ width, progressShow }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let interval: NodeJS.Timeout; // 타이머 변수

    interval = setInterval(() => {
      if (width < 100) {
        setProgress((prevProgress) => prevProgress + 1);
      } else {
        clearInterval(interval); // 프로그레스바가 100%가 되면 타이머 해제
      }
    }, 300); // 0.3초마다 진행

    // 최대 30초로 제한
    const timeout = setTimeout(() => {
      clearInterval(interval); // 30초 후에 타이머 해제
    }, 30000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout); // 컴포넌트 언마운트 시 타이머 정리
    };
  }, [width]);

  return (
    <div className="progress-wrap">
      <span>예약정보 및 교환증 출력이 진행중입니다...</span>
      <ProgressBarContainer>
        <Progress width={progress}></Progress>
      </ProgressBarContainer>
    </div>
  );
};

export default ProgressBar;
